import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'card_page_filters';
export const useCardPageFiltersTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  from: 'От',
  to: 'До',
  date_title: 'Дата создания',
  face_ids_title: 'ID лиц',
  user_data_title: 'Информация',
  reset_button: 'Очистить',
}) as Record<string, unknown>;

export const en = ({
  from: 'From',
  to: 'To',
  date_title: 'Creation date',
  face_ids_title: 'Face IDs',
  user_data_title: 'User data',
  reset_button: 'Reset',
}) as Record<string, unknown>;

export const ptBr = ({
  from: 'De',
  to: 'Até',
  date_title: 'Data de criação',
  face_ids_title: 'IDs de faces',
  user_data_title: 'Dados do usuário',
  reset_button: 'Limpar',
}) as Record<string, unknown>;

export const esEs = ({
  from: 'Desde',
  to: 'Hasta',
  date_title: 'Fecha de creación',
  face_ids_title: 'IDs de rostros',
  user_data_title: 'Datos del usuario',
  reset_button: 'Limpiar',
}) as Record<string, unknown>;
